import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import app from 'flarum/forum/app';

import { INavItem } from '../common/utils';
import UserInfo from './components/UserInfo';
import NavList from './components/NavList';

export default function () {
  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    items.setPriority('newDiscussion', 50);
    items.add(
      'extraNavList',
      <div className="ExtraNav">
        <UserInfo />
        <NavList />
      </div>,
      4
    );
  });
}
